import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium'

export const DEFAULT_COLUMN_WIDTH = 200
export const DEFAULT_MINIMUM_COLUMN_WIDTH = 80
export const DEFAULT_MINIMUM_DATE_COLUMN_WIDTH = 120
export const DEFAULT_MINIMUM_ID_COLUMN_WIDTH = 120
export const DEFAULT_MINIMUM_LEFT_PINNED_COLUMN_WIDTH = 250
export const DEFAULT_MINIMUM_DROPDOWN_COLUMN_WIDTH = 110
export const DEFAULT_WIDE_TEXT_COLUMN_WIDTH = 400
export const DEFAULT_MINIMUM_WIDE_TEXT_COLUMN_WIDTH = 280

// TODO (Dalyan): We will need to consolidate these two functions after we consolidate DataGridBase and DataGridEditable
export const applyDefaultColumnDefinitionsToColumns = <T extends GridValidRowModel>(columns: GridColDef<T>[]): GridColDef<T>[] =>
  columns.map((column) => ({
    ...column,
    flex: 0,
    width: column.width ?? DEFAULT_COLUMN_WIDTH,
    minWidth: column.minWidth ?? DEFAULT_MINIMUM_COLUMN_WIDTH,
    groupable: column.groupable ?? false,
  }))

export const applyDefaultColumnDefinitionsToDataGridEditableColumns = <T extends GridValidRowModel>(
  columns: GridColDef<T>[]
): GridColDef<T>[] =>
  columns.map((column) => ({
    ...column,
    groupable: false,
  }))
